var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { apiFetcher } from "@common/fetchers/api-fetcher";
import { ENDPOINTS } from "@common/constants/endpoints";
import useSWRInfinite from "swr/infinite";
import { useMemo, useState } from "react";
var PAGE_SIZE_DEFAULT = 50;
var toListKeyParam = function (values, paramKey) {
    if (!values)
        return "";
    return values === null || values === void 0 ? void 0 : values.reduce(function (prev, value) {
        return !value ? prev : "".concat(prev ? "".concat(prev, "&") : "&").concat(paramKey, "=").concat(value);
    }, "");
};
var useFindEducationCollection = function (startNodeId, pageSize, locale, useFilters) {
    var requestOptions = useMemo(function () { return ({
        method: "GET",
    }); }, []);
    var _a = __read(useState(null), 2), selectedStartDates = _a[0], setSelectedStartDates = _a[1];
    var _b = __read(useState(null), 2), selectedPlaces = _b[0], setSelectedPlaces = _b[1];
    var _c = __read(useState(null), 2), selectedEducationLanguages = _c[0], setSelectedEducationLanguage = _c[1];
    var _d = __read(useState(null), 2), selectedEducationType = _d[0], setSelectedEducationType = _d[1];
    var _e = __read(useState(null), 2), selectedModuleAreas = _e[0], setSelectedModuleAreas = _e[1];
    var _f = __read(useState(null), 2), selectedAcademicLevel = _f[0], setSelectedAcademicLevel = _f[1];
    var _g = __read(useState(null), 2), selectedAcademicArea = _g[0], setSelectedAcademicArea = _g[1];
    var _h = __read(useState(null), 2), selectedExchangeType = _h[0], setSelectedExchangeType = _h[1];
    var _j = __read(useState(null), 2), selectedStartOfTerm = _j[0], setSelectedStartOfTerm = _j[1];
    var _k = __read(useState(null), 2), selectedTeachingMethods = _k[0], setSelectedTeachingMethods = _k[1];
    var _l = __read(useState(""), 2), search = _l[0], setSearch = _l[1];
    var filtersCount = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return ({
            academicArea: (_a = selectedAcademicArea === null || selectedAcademicArea === void 0 ? void 0 : selectedAcademicArea.length) !== null && _a !== void 0 ? _a : 0,
            academicLevel: (_b = selectedAcademicLevel === null || selectedAcademicLevel === void 0 ? void 0 : selectedAcademicLevel.length) !== null && _b !== void 0 ? _b : 0,
            educationBegins: (_c = selectedStartDates === null || selectedStartDates === void 0 ? void 0 : selectedStartDates.length) !== null && _c !== void 0 ? _c : 0,
            educationTypes: (_d = selectedEducationType === null || selectedEducationType === void 0 ? void 0 : selectedEducationType.length) !== null && _d !== void 0 ? _d : 0,
            exchangeType: (_e = selectedExchangeType === null || selectedExchangeType === void 0 ? void 0 : selectedExchangeType.length) !== null && _e !== void 0 ? _e : 0,
            languages: (_f = selectedEducationLanguages === null || selectedEducationLanguages === void 0 ? void 0 : selectedEducationLanguages.length) !== null && _f !== void 0 ? _f : 0,
            moduleAreas: (_g = selectedModuleAreas === null || selectedModuleAreas === void 0 ? void 0 : selectedModuleAreas.length) !== null && _g !== void 0 ? _g : 0,
            places: (_h = selectedPlaces === null || selectedPlaces === void 0 ? void 0 : selectedPlaces.length) !== null && _h !== void 0 ? _h : 0,
            startOfTerm: (_j = selectedStartOfTerm === null || selectedStartOfTerm === void 0 ? void 0 : selectedStartOfTerm.length) !== null && _j !== void 0 ? _j : 0,
            teachingMethods: (_k = selectedTeachingMethods === null || selectedTeachingMethods === void 0 ? void 0 : selectedTeachingMethods.length) !== null && _k !== void 0 ? _k : 0,
        });
    }, [
        selectedStartDates,
        selectedPlaces,
        selectedEducationLanguages,
        selectedEducationType,
        selectedModuleAreas,
        selectedAcademicLevel,
        selectedAcademicArea,
        selectedExchangeType,
        selectedStartOfTerm,
        selectedTeachingMethods,
    ]);
    var clearFilters = function () {
        setSelectedStartDates(null);
        setSelectedPlaces(null);
        setSelectedEducationLanguage(null);
        setSelectedEducationType(null);
        setSelectedModuleAreas(null);
        setSelectedAcademicLevel(null);
        setSelectedAcademicArea(null);
        setSelectedExchangeType(null);
        setSelectedStartOfTerm(null);
        setSelectedTeachingMethods(null);
    };
    var getKey = function (pageIndex, previousPageData) {
        var _a, _b;
        if (previousPageData && !((_a = previousPageData === null || previousPageData === void 0 ? void 0 : previousPageData.collection) === null || _a === void 0 ? void 0 : _a.length))
            return null;
        return [
            "".concat(ENDPOINTS.findEducation, "?&search=").concat(search !== null && search !== void 0 ? search : "").concat(toListKeyParam(selectedPlaces, "place")).concat(toListKeyParam(selectedEducationType, "educationType")).concat(toListKeyParam(selectedModuleAreas, "moduleArea")).concat(toListKeyParam(selectedAcademicLevel, "academicLevel")).concat(toListKeyParam(selectedAcademicArea, "academicArea")).concat(toListKeyParam(selectedExchangeType, "exchangeType")).concat(toListKeyParam(selectedTeachingMethods, "teachingMethod")).concat(toListKeyParam(selectedStartOfTerm, "startOfTerm")).concat(toListKeyParam(selectedEducationLanguages, "educationLanguage")).concat(toListKeyParam(selectedStartDates, "startDate"), "&pageSize=").concat(pageSize || PAGE_SIZE_DEFAULT, "&pageNumber=").concat(pageIndex + 1).concat(toListKeyParam(startNodeId, "startNodeId"), "&culture=").concat(locale, "&sortingCriterion=").concat(((_b = useFilters === null || useFilters === void 0 ? void 0 : useFilters.cfuEducation) !== null && _b !== void 0 ? _b : false)
                ? "startDate"
                : "alphabetically"),
            requestOptions,
        ];
    };
    var _m = useSWRInfinite(getKey, apiFetcher), data = _m.data, error = _m.error, isValidating = _m.isValidating, mutate = _m.mutate, size = _m.size, setSize = _m.setSize;
    return {
        educationCollection: data,
        isLastPage: !!(data === null || data === void 0 ? void 0 : data.find(function (x) { return !x.hasNextPage; })),
        error: error,
        isValidating: isValidating,
        mutate: mutate,
        size: size,
        setSize: setSize,
        setSelectedStartDates: setSelectedStartDates,
        setSelectedPlaces: setSelectedPlaces,
        setSelectedEducationLanguage: setSelectedEducationLanguage,
        setSelectedEducationType: setSelectedEducationType,
        setSelectedModuleAreas: setSelectedModuleAreas,
        setSelectedAcademicLevel: setSelectedAcademicLevel,
        setSelectedAcademicArea: setSelectedAcademicArea,
        setSelectedExchangeType: setSelectedExchangeType,
        setSelectedStartOfTerm: setSelectedStartOfTerm,
        setSelectedTeachingMethods: setSelectedTeachingMethods,
        selectedStartDates: selectedStartDates,
        selectedPlaces: selectedPlaces,
        selectedEducationLanguages: selectedEducationLanguages,
        selectedEducationType: selectedEducationType,
        selectedModuleAreas: selectedModuleAreas,
        selectedAcademicLevel: selectedAcademicLevel,
        selectedAcademicArea: selectedAcademicArea,
        selectedExchangeType: selectedExchangeType,
        selectedStartOfTerm: selectedStartOfTerm,
        selectedTeachingMethods: selectedTeachingMethods,
        search: search,
        setSearch: setSearch,
        totalResultsCount: data === null || data === void 0 ? void 0 : data[0].totalCount,
        clearFilters: clearFilters,
        filtersCount: filtersCount,
    };
};
export { useFindEducationCollection, toListKeyParam };
